export const CHARCOAL = '#333333';
export const LIGHT_GRAY = '#D3D3D3';
export const LIGHT_SQUARE = '#FFF';
export const DARK_SQUARE = '#2867B2';
export const ROYAL_BLUE = '#2867B2';
export const BOARD_HIGHLIGHT_COLOR = '#8aa67e';

export const AVATAR_COLORS = ['#00AA55', '#009FD4', '#B381B3', '#939393', '#E3BC00', '#D47500', '#DC2A2A'];
